import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const MagnifyingGlassIllustration = ({
  width = 160,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              fill="#94C9E2"
              d="M16.296 66.688c0-27.732 22.436-50.296 50.02-50.296 27.577 0 50.02 22.564 50.02 50.296 0 27.736-22.443 50.3-50.02 50.3-27.584 0-50.02-22.564-50.02-50.3m139.729 70l-33.916-34.096c6.628-10.376 10.524-22.68 10.524-35.904C132.633 29.924 102.88 0 66.316 0 29.748 0 0 29.924 0 66.688c0 36.768 29.748 66.688 66.316 66.688 13.612 0 26.269-4.156 36.809-11.26l33.696 33.888c2.648 2.664 6.12 3.996 9.596 3.996s6.952-1.332 9.608-3.996c5.3-5.34 5.3-13.98 0-19.316"
              transform="translate(-304 -220) translate(304 220)"
            />
            <path
              fill="#231F20"
              fillOpacity=".1"
              d="M156.054 136.688l-33.669-34.096c6.584-10.376 10.448-22.68 10.448-35.904C132.833 29.924 103.297 0 67 0v16.392c27.379 0 49.655 22.564 49.655 50.296 0 27.736-22.276 50.3-49.655 50.3v16.388c13.517 0 26.08-4.156 36.54-11.26l33.45 33.888c2.629 2.664 6.075 3.996 9.53 3.996 3.45 0 6.897-1.332 9.534-3.996 5.261-5.34 5.261-13.98 0-19.316"
              transform="translate(-304 -220) translate(304 220)"
            />
            <path
              fill="#94C9E2"
              d="M32.347 66.502C32.347 48.697 40.888 32.913 54 23c-19.044 5.539-33 22.928-33 43.502 0 20.57 13.956 37.96 33 43.498-13.112-9.913-21.653-25.697-21.653-43.498"
              transform="translate(-304 -220) translate(304 220)"
            />
            <path
              fill="#231F20"
              fillOpacity=".1"
              d="M32.347 66.502C32.347 48.697 40.888 32.913 54 23c-19.044 5.539-33 22.928-33 43.502 0 20.57 13.956 37.96 33 43.498-13.112-9.913-21.653-25.697-21.653-43.498"
              transform="translate(-304 -220) translate(304 220)"
            />
            <path
              fill="#B2B2B2"
              d="M70.606 66.502l8.542-8.545c1.136-1.132 1.136-2.973 0-4.105-1.128-1.136-2.977-1.136-4.105 0l-8.542 8.546-8.541-8.546c-1.128-1.136-2.977-1.136-4.105 0-1.14 1.132-1.14 2.973 0 4.105l8.542 8.545-8.542 8.542c-1.14 1.132-1.14 2.973 0 4.105.562.57 1.31.851 2.05.851.744 0 1.489-.281 2.055-.851l8.541-8.542 8.542 8.542c.566.57 1.31.851 2.055.851.74 0 1.488-.281 2.05-.851 1.136-1.132 1.136-2.973 0-4.105l-8.542-8.542z"
              transform="translate(-304 -220) translate(304 220)"
            />
            <path
              fill="#231F20"
              fillOpacity=".1"
              d="M67 70.608l8.226 8.541c.545.57 1.262.851 1.979.851.713 0 1.433-.281 1.974-.85 1.095-1.133 1.095-2.973 0-4.105l-8.226-8.541 8.226-8.545c1.095-1.132 1.095-2.972 0-4.104-1.086-1.14-2.866-1.14-3.953 0L67 62.4v8.208z"
              transform="translate(-304 -220) translate(304 220)"
            />
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
